import { rio } from '@amzn/rio-design-tokens';
// Some colors from figma do not exist in rio, but are defined by the prime team or @davflink
export const colors = {
    primeBlue: rio.semantic.color.retail.prime,
    headerFooterLightMode: rio.base.color.blue[10],
    headerFooterDarkMode: '#0F141A',
};
